module.exports = __webpack_public_path__ + "static/IMG_0379-cc29bbc8192e037c1983aa52c99f7ef9.jpg";